// TODO(cochamberlain): Deprecate this.
/** Jupyter event names. */
export enum JupyterEvent {
  APP_INIT = "app_initialized.NotebookApp",
  KERNEL_BUSY = "kernel_busy.Kernel",
  KERNEL_IDLE = "kernel_idle.Kernel",
  NOTEBOOK_LOADED = "notebook_loaded.Notebook",
  KERNEL_READY = "kernel_ready.Kernel",
  KERNEL_DISCONNECTED = "kernel_disconnected.Kernel",
  KERNEL_KILLED = "kernel_killed.Session",
  KERNEL_RESTARTING = "kernel_restarting.Kernel",
  KERNEL_CONNECTION_FAILED = "kernel_connection_failed.Kernel",
  CELL_CHANGE = "change.Cell",
  CELL_DELETE = "delete.Cell",
  CELL_CREATE = "create.Cell",
  CELL_COMMAND_MODE = "command_mode.Cell",
  CELL_EDIT_MODE = "edit_mode.Cell",
  // Using "active" to represent here since "select" adds confusion to text selection.
  CELL_ACTIVE = "select.Cell",
  CODE_CELL_EXECUTE = "execute.CodeCell",
  ACTIVE_CELL_TYPE_CHANGED = "selected_cell_type_changed.Notebook",
  OUTPUT_ADDED = "output_added.OutputArea",
}
